// extracted by mini-css-extract-plugin
export const cost = "cost-module--cost--1VX8k";